<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text">
            Registrar pago en caja de ahorro
            <router-link :to="{ name: 'CajaAhorro', params: { config: config } }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="9" md="9" lg="9">
                  <CAlert fade color="danger" class="mb-1 mt-4" :show.sync="alertError">{{message}}</CAlert>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha de apgo:</label>
                <CInput :value.sync="$v.date.$model" :isValid="checkIfValid('date')" type="date"
                  :horizontal="{ input: 'col-sm-12' }" invalidFeedback="Campo requerido" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Monto:</label>
                <CInput v-model="monto"  type="number"
                  :horizontal="{ input: 'col-sm-12' }" invalidFeedback="Campo requerido" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="9" md="9" lg="9">
                  <CAlert fade color="success" class="mb-1 mt-4" :show.sync="alertSuccess">Guardado con éxito.</CAlert>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'CajaAhorro', params: { config: config } }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>

            <CButton v-if="isLoading" class="px-4 mx-3 btn-lg" color="success">
              <div>
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
            </CButton>
            <CButton v-else @click="guardarPago()" class="px-4 mx-3 btn-lg" color="success">
              <span>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
      <!-- <CModal size="sm" title="Salida" :centered="true" color="warning" :show.sync="warningModal">{{ error }}</CModal> -->
    </CRow>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";

export default {
  name: "NuevoProrroga",

  components: {
    Multiselect,
    vSelect
  },

  data() {
    return {
      date: null,
      monto : null,
      config: this.$route.params.config,
      error: "",
      alertSuccess : false,
      alertError : false,
      isLoading : false,
      message : ''
    };
  },

  mixins: [validationMixin],
  validations: {
    date: {
      required
    }
  },
  computed: {
    isValidDate() {
      return !this.$v.date.$invalid;
    }
  },
  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },
  created() {
    this.isLoadingPage = true;
    const ubi = [
      this.$store.dispatch("customHTTP", {
        schema: "trabajadores",
        filter: {
          where: [
            {
              field: "payload->ubicaciones",
              operator: "regexp",
              value: `[[:<:]]${this.ubicacionRaizValue}[[:>:]]`
            },
            {
              field: "payload->suspendido",
              operator: "=",
              value: false
            }
          ],
        }
      })
    ];
    Promise.all(ubi)
      .then(([trabajadores]) => {
        this.trabajadores = trabajadores.data.map(trabajador => {
          return { value: trabajador.id, label: trabajador.payload.nombre };
        });
        this.trabajadoresAll = trabajadores.data;
      })
      .finally(() => (this.isLoadingPage = false));
  },

  methods: {

    updateCombos() {
      this.isLoadingPage = true;
      this.$store;

      const ubi = [
        this.$store.dispatch("customHTTP", {
          schema: "trabajadores",
          filter: {
            where: [
              {
                field: "payload->ubicaciones",
                operator: "regexp",
                value: `[[:<:]]${this.ubicacionRaizValue}[[:>:]]`
              },
              {
                field: "payload->suspendido",
                operator: "=",
                value: false
              },
            ],
          }
        })
      ];
      Promise.all(ubi)
        .then(([trabajadores]) => {
          this.trabajadores = trabajadores.data.map(trabajador => {
            return { value: trabajador.id, label: trabajador.payload.nombre };
          });

          this.trabajadoresAll = trabajadores.data;
        })
        .finally(() => (this.isLoadingPage = false));
    },

    guardarPago() {
        if(this.date ==  null) {
            this.showError('Ingresa una fecha de prorroga valida');
        }else if( this.monto === null || this.monto <= 0){
          this.showError('No puedes efectuar un pago menor igual a 0 pesos ');
        }else {
          console.log(this.date);
          console.log(this.monto);
          this.isLoadingPage = true;
          this.$store.dispatch("customDocumentoActualizarHTTP", {
            schema: "caja_de_ahorro",
            folio: this.$route.params.id ,
            payload: {
              pagos: [ { fecha: this.date, monto : parseInt( this.monto)} ]
            }
          }).then((data) => {
            this.alertSuccess = true
          }).catch(error => {
            this.showError(error.message);
          }).finally(() => {
            this.isLoading = false;
          });
        }

    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateProroga() {
      this.$v.date.$touch();
    },
    showError(message){
        this.alertError = true;
        this.message = message
        setTimeout(() => {
            this.alertError = false;
            return;
        }, 2000);
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
.cursor-p {
  cursor: pointer;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
